export const CONTAINER_MAX_WIDTH = '1920px'
